import { render, staticRenderFns } from "./LinkUpdatePhone.vue?vue&type=template&id=1a0c9846&"
import script from "./LinkUpdatePhone.vue?vue&type=script&lang=js&"
export * from "./LinkUpdatePhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports